import {UserGlobalRole} from "../types/domain/user";
import {CompanyMemberRole} from "../types/domain/companyMember";
import {LanguageType} from "../types/domain/languageType";
import {EnumItem, LocalizedEnumItem} from "../types/enumItem";
import {MeasureSystemType} from "../types/domain/measureSystemType";
import {TableFilterSelectOption} from "../types/table";
import {ContactSupportReason} from "../types/domain/contactSupportReason";
import {ExportFileFormatType} from "../types/domain/exportFileFormatType";
import {ExportFileRangeType} from "../types/domain/exportFileRangeType";
import {MeasureUnitType} from "../types/domain/measureUnitType";

export const enumItemToTableFilterSelectOption = (enumItem: EnumItem): TableFilterSelectOption => ({
    value: enumItem.id,
    label: enumItem.label,
});

export const ALL: LocalizedEnumItem & EnumItem = {id: "ALL", i18nKey: "enumerations.all", label: "All"};

export const SOILS: LocalizedEnumItem[] = [
    {id: "0", i18nKey: "undefined"},
    {id: "1", i18nKey: "silty_clay"},
    {id: "2", i18nKey: "silty_clay_loam"},
    {id: "3", i18nKey: "silt"},
    {id: "4", i18nKey: "clay"},
    {id: "5", i18nKey: "silty_loam"},
    {id: "6", i18nKey: "clay_loam"},
    {id: "7", i18nKey: "medium_loam"},
    {id: "8", i18nKey: "sandy_clay"},
    {id: "9", i18nKey: "sandy_clay_loam"},
    {id: "10", i18nKey: "sandy_loam"},
    {id: "11", i18nKey: "loamy_sand"},
    {id: "12", i18nKey: "sand"},
];

export const IRRIGATIONS: LocalizedEnumItem[] = [
    {id: "0", i18nKey: "undefined"},
    {id: "1", i18nKey: "drip"},
    {id: "2", i18nKey: "sub_surface_drip"},
    {id: "3", i18nKey: "sprinkler"},
    {id: "4", i18nKey: "center_pivot"},
    {id: "5", i18nKey: "traveling_gun"},
    {id: "6", i18nKey: "furrow"},
    {id: "7", i18nKey: "basin"},
    {id: "8", i18nKey: "border"},
    {id: "9", i18nKey: "micro_sprinklers"},
    {id: "10", i18nKey: "no_irrigation"},
    {id: "11", i18nKey: "non_irrigated"},
    {id: "12", i18nKey: "dragon_line"},
    {id: "13", i18nKey: "linear_move"},
];

export const CROPS: LocalizedEnumItem[] = [
    {id: "1", i18nKey: "wheat"},
    {id: "2", i18nKey: "corn"},
    {id: "3", i18nKey: "sweet_corn"},
    {id: "4", i18nKey: "barley"},
    {id: "5", i18nKey: "rice"},
    {id: "6", i18nKey: "sorghum"},
    {id: "7", i18nKey: "millet"},
    {id: "8", i18nKey: "oats"},
    {id: "9", i18nKey: "flax"},
    {id: "10", i18nKey: "teff"},
    {id: "11", i18nKey: "ryegrass"},
    {id: "12", i18nKey: "triticale"},
    {id: "13", i18nKey: "rye"},
    {id: "100", i18nKey: "sugarbeet"},
    {id: "101", i18nKey: "potato"},
    {id: "102", i18nKey: "sweet_potato"},
    {id: "103", i18nKey: "cassave"},
    {id: "104", i18nKey: "ginger"},
    {id: "105", i18nKey: "turmeric"},
    {id: "200", i18nKey: "sugarcane"},
    {id: "300", i18nKey: "citrus"},
    {id: "301", i18nKey: "almonds"},
    {id: "302", i18nKey: "walnuts"},
    {id: "303", i18nKey: "olives"},
    {id: "304", i18nKey: "cedar_elm"},
    {id: "305", i18nKey: "apples"},
    {id: "306", i18nKey: "abricots"},
    {id: "307", i18nKey: "cherries"},
    {id: "308", i18nKey: "nectarines"},
    {id: "309", i18nKey: "peaches"},
    {id: "310", i18nKey: "plums"},
    {id: "311", i18nKey: "prunes"},
    {id: "312", i18nKey: "avocado"},
    {id: "313", i18nKey: "kiwi"},
    {id: "314", i18nKey: "pistachio"},
    {id: "315", i18nKey: "pears"},
    {id: "316", i18nKey: "pomegranate"},
    {id: "317", i18nKey: "figs"},
    {id: "318", i18nKey: "carob"},
    {id: "319", i18nKey: "lemon"},
    {id: "320", i18nKey: "persimmon"},
    {id: "321", i18nKey: "cacao"},
    {id: "322", i18nKey: "hazelnut"},
    {id: "323", i18nKey: "pecan_nut"},
    {id: "324", i18nKey: "macadania_nut"},
    {id: "325", i18nKey: "tree_nursery"},
    {id: "326", i18nKey: "guava"},
    {id: "327", i18nKey: "mandarin"},
    {id: "328", i18nKey: "argan"},
    {id: "400", i18nKey: "banana"},
    {id: "401", i18nKey: "date_palm"},
    {id: "402", i18nKey: "coffee"},
    {id: "403", i18nKey: "coconut"},
    {id: "404", i18nKey: "pineapple"},
    {id: "405", i18nKey: "rubber"},
    {id: "406", i18nKey: "tea"},
    {id: "407", i18nKey: "cantaloupe"},
    {id: "408", i18nKey: "dragon_fruit"},
    {id: "409", i18nKey: "oil_palm"},
    {id: "410", i18nKey: "mango"},
    {id: "411", i18nKey: "agave"},
    {id: "412", i18nKey: "papaya"},
    {id: "413", i18nKey: "lychee"},
    {id: "500", i18nKey: "onion"},
    {id: "501", i18nKey: "lettuce"},
    {id: "502", i18nKey: "broccoli"},
    {id: "503", i18nKey: "cabbage"},
    {id: "504", i18nKey: "carrots"},
    {id: "505", i18nKey: "celery"},
    {id: "506", i18nKey: "cauliflower"},
    {id: "507", i18nKey: "garlic"},
    {id: "508", i18nKey: "pepper"},
    {id: "509", i18nKey: "spinach"},
    {id: "510", i18nKey: "tomato"},
    {id: "511", i18nKey: "egg_plant"},
    {id: "512", i18nKey: "cucumber"},
    {id: "513", i18nKey: "melon"},
    {id: "514", i18nKey: "strawberries"},
    {id: "515", i18nKey: "lady_finger"},
    {id: "516", i18nKey: "radish"},
    {id: "517", i18nKey: "fennel"},
    {id: "518", i18nKey: "pumpkin"},
    {id: "519", i18nKey: "asparagus"},
    {id: "520", i18nKey: "chicory_witlof"},
    {id: "521", i18nKey: "beetroot_rode_biet"},
    {id: "522", i18nKey: "quinoia"},
    {id: "523", i18nKey: "mint"},
    {id: "524", i18nKey: "squash"},
    {id: "525", i18nKey: "water_melon"},
    {id: "526", i18nKey: "coriander"},
    {id: "527", i18nKey: "leek"},
    {id: "528", i18nKey: "basil"},
    {id: "529", i18nKey: "zucchini"},
    {id: "530", i18nKey: "prickly_pears_vijgcactus"},
    {id: "531", i18nKey: "parsley"},
    {id: "532", i18nKey: "marjoram"},
    {id: "533", i18nKey: "thyme"},
    {id: "534", i18nKey: "spring_onion"},
    {id: "535", i18nKey: "chili_pepper"},
    {id: "536", i18nKey: "tomatillo"},
    {id: "537", i18nKey: "dill"},
    {id: "600", i18nKey: "grapes_table"},
    {id: "601", i18nKey: "grapes_wine"},
    {id: "602", i18nKey: "blue_berries"},
    {id: "603", i18nKey: "hops"},
    {id: "604", i18nKey: "rossins"},
    {id: "605", i18nKey: "black_berries"},
    {id: "606", i18nKey: "rasp_berries"},
    {id: "607", i18nKey: "red_berries"},
    {id: "608", i18nKey: "ashwagandha"},
    {id: "609", i18nKey: "cardamom"},
    {id: "610", i18nKey: "black_pepper"},
    {id: "700", i18nKey: "sunflower"},
    {id: "701", i18nKey: "rapeseed_canola_mustard"},
    {id: "702", i18nKey: "cumin"},
    {id: "703", i18nKey: "mustard"},
    {id: "800", i18nKey: "green_beans"},
    {id: "801", i18nKey: "soya_beans"},
    {id: "802", i18nKey: "peas"},
    {id: "803", i18nKey: "peanut"},
    {id: "804", i18nKey: "faba_beans"},
    {id: "805", i18nKey: "lentil"},
    {id: "806", i18nKey: "fenugreek"},
    {id: "807", i18nKey: "gram_or_chickpea"},
    {id: "808", i18nKey: "serradella"},
    {id: "900", i18nKey: "cotton"},
    {id: "901", i18nKey: "tobacco"},
    {id: "902", i18nKey: "sesam"},
    {id: "903", i18nKey: "hemp"},
    {id: "1000", i18nKey: "alfalafa"},
    {id: "1001", i18nKey: "pasture_shallow_roots"},
    {id: "1002", i18nKey: "turf_grass"},
    {id: "1003", i18nKey: "sudan_grass_tall"},
    {id: "1004", i18nKey: "clover"},
    {id: "1005", i18nKey: "forage_radish"},
    {id: "1006", i18nKey: "pasture_deep_roots"},
    {id: "1007", i18nKey: "rhodes_grass"},
    {id: "1008", i18nKey: "golf_greens"},
    {id: "1009", i18nKey: "golf_fairways"},
    {id: "1010", i18nKey: "golf_tees"},
    {id: "1011", i18nKey: "golf_roughs"},
    {id: "1100", i18nKey: "rose_geraniums"},
    {id: "1101", i18nKey: "tulip"},
    {id: "1102", i18nKey: "lely"},
    {id: "1103", i18nKey: "hyacint"},
    {id: "1104", i18nKey: "daffodil_narcis"},
    {id: "1105", i18nKey: "gladiolus"},
    {id: "1106", i18nKey: "peonies_pioenrozen"},
    {id: "1107", i18nKey: "saffron"},
    {id: "1108", i18nKey: "muscacari"},
    {id: "1109", i18nKey: "chionodoxa"},
    {id: "2000", i18nKey: "other"},
    {id: "2001", i18nKey: "fallow"},
    {id: "2002", i18nKey: "water"},
    {id: "2003", i18nKey: "forest"},
    {id: "2004", i18nKey: "urban"},
    {id: "2005", i18nKey: "desert_plantation"},
    {id: "2006", i18nKey: "arak"},
    {id: "2007", i18nKey: "ghaf"},
    {id: "2008", i18nKey: "jujube"},
    {id: "3001", i18nKey: "dryland_wheat"},
];

export const USER_GLOBAL_ROLES: EnumItem<UserGlobalRole>[] = [
    {id: UserGlobalRole.USER, label: "User"},
    {id: UserGlobalRole.HYDROSAT, label: "Hydrosat"},
    {id: UserGlobalRole.CS, label: "CS"},
    {id: UserGlobalRole.ADMIN, label: "Admin"},
];

export const COMPANY_MEMBER_ROLES: LocalizedEnumItem<CompanyMemberRole>[] = [
    {id: CompanyMemberRole.VIEWER, i18nKey: "enumerations.company_roles.viewer"},
    {id: CompanyMemberRole.EDITOR, i18nKey: "enumerations.company_roles.editor"},
    {id: CompanyMemberRole.MANAGER, i18nKey: "enumerations.company_roles.manager"},
];

export const LANGUAGES: EnumItem<LanguageType>[] = [
    {id: LanguageType.ENGLISH, label: "English"},
    {id: LanguageType.FRANCAIS, label: "Français"},
    {id: LanguageType.ITALIANO, label: "Italiano"},
    {id: LanguageType.ESPANOL, label: "Español"},
    {id: LanguageType.NEDERLANDS, label: "Nederlands"},
    {id: LanguageType.ARABIC, label: "Arabic"},
    {id: LanguageType.DEUTSCH, label: "Deutsch"},
    {id: LanguageType.HINDI, label: "Hindi"},
    {id: LanguageType.PORTUGUESE, label: "Portuguese"},
];

export const MEASURE_SYSTEMS: LocalizedEnumItem<MeasureSystemType>[] = [
    {id: MeasureSystemType.IMPERIAL, i18nKey: "enumerations.measurement_systems.imperial"},
    {id: MeasureSystemType.METRIC, i18nKey: "enumerations.measurement_systems.metric"},
];

export const MEASURE_UNITS: LocalizedEnumItem<MeasureUnitType>[] = [
    {id: MeasureUnitType.ACRE, i18nKey: "enumerations.measure_units.acre"},
    {id: MeasureUnitType.HECTARE, i18nKey: "enumerations.measure_units.hectare"},

    {id: MeasureUnitType.METER_PER_SECOND, i18nKey: "enumerations.measure_units.meter_per_second"},
    {id: MeasureUnitType.MILE_PER_HOUR, i18nKey: "enumerations.measure_units.mile_per_hour"},

    {id: MeasureUnitType.MM, i18nKey: "enumerations.measure_units.millimeter"},
    {id: MeasureUnitType.INCH, i18nKey: "enumerations.measure_units.inch"},

    {id: MeasureUnitType.METER, i18nKey: "enumerations.measure_units.meter"},
    {id: MeasureUnitType.FOOT, i18nKey: "enumerations.measure_units.feet"},

    {id: MeasureUnitType.KG_PER_HECTARE, i18nKey: "enumerations.measure_units.kg_per_hectare"},
    {id: MeasureUnitType.LB_PER_ACRE, i18nKey: "enumerations.measure_units.lb_per_acre"},

    {id: MeasureUnitType.HPA, i18nKey: "enumerations.measure_units.hpa"},
    {id: MeasureUnitType.PSI, i18nKey: "enumerations.measure_units.psi"},
];

export const COMPANY_MEMBER_TYPES: LocalizedEnumItem[] = [
    {id: "MEMBER", i18nKey: "enumerations.company_member_types.member"},
    {id: "INVITED", i18nKey: "enumerations.company_member_types.invited"},
];

export const USER_TYPES: LocalizedEnumItem[] = [
    {id: "ADVANCED", i18nKey: "enumerations.user_types.advanced"},
    {id: "NOT_ADVANCED", i18nKey: "enumerations.user_types.not_advanced"},
];

export const CONTACT_SUPPORT_REASONS: LocalizedEnumItem<ContactSupportReason>[] = [
    {id: ContactSupportReason.SUBS_SALES, i18nKey: "dialogs.contact_support.reasons.subs_sales"},
    {id: ContactSupportReason.USER_MGMT, i18nKey: "dialogs.contact_support.reasons.user_mgmt"},
    {id: ContactSupportReason.FIELD_MGMT, i18nKey: "dialogs.contact_support.reasons.field_mgmt"},
    {id: ContactSupportReason.DATA_MODEL, i18nKey: "dialogs.contact_support.reasons.data_model"},
    {id: ContactSupportReason.API, i18nKey: "dialogs.contact_support.reasons.api"},
    {id: ContactSupportReason.PORTAL_FEEDBACK, i18nKey: "dialogs.contact_support.reasons.portal_feedback"},
    {id: ContactSupportReason.OTHER, i18nKey: "dialogs.contact_support.reasons.other"},
];

export const EXPORT_FILE_FORMAT_TYPES: EnumItem<ExportFileFormatType>[] = [
    {id: ExportFileFormatType.CSV, label: "CSV"},
    {id: ExportFileFormatType.XLSX, label: "Excel .xlsx"},
    {id: ExportFileFormatType.JSON, label: "JSON"},
];

export const EXPORT_FILE_RANGE_TYPES: LocalizedEnumItem<ExportFileRangeType>[] = [
    {id: ExportFileRangeType.LATEST_DAY, i18nKey: "dialogs.data_download.date_range.latest_day"},
    {id: ExportFileRangeType.FULL_HISTORY, i18nKey: "dialogs.data_download.date_range.full_history"},
    {id: ExportFileRangeType.SPECIFIC_RANGE, i18nKey: "dialogs.data_download.date_range.specific_range"},
];

export const BOOLEAN_OPTIONS: LocalizedEnumItem<"YES" | "NO">[] = [
    {id: "YES", i18nKey: "enumerations.boolean.yes"},
    {id: "NO", i18nKey: "enumerations.boolean.no"},
];
